import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { TokenContent } from "src/app/shared/interfaces/token-data";
import { AppLoaderService } from "src/app/shared/services/app-loader.service";
import { LoggedInService } from "../loggedin.service";
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private readonly loggedInService: LoggedInService,
    private readonly loaderService: AppLoaderService,
    private readonly router: Router,
  ) {
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem("PING_ACCESS_TOKEN");
    const menu = sessionStorage.getItem("MENU_LOADED");
    const isAuthorizationsRequest = req.url.includes('/authorizations/');

    if (this.loggedInService.tokenIsNullOrEmpty(token)) {
      return next.handle(req);
    }

    if (isAuthorizationsRequest || this.checkMenu(menu)) {
      this.checkTokenValidation(token);
      const headers = new HttpHeaders().set('Authorization', `bearer ${token}`);
      req = req.clone({ headers });
    }

    return next.handle(req);
  }

  private checkMenu(menu: any): boolean {

    if( menu == "false"){
      return false;
    }

    return true;
  }

  private checkTokenValidation(token: any): boolean {

    const tokenExpired = this.loggedInService.handleTokenExpiration(token);

    if(tokenExpired){
      this.router.navigate(['registro-credito'])
      this.loggedInService.redirectToPing();
      return false;
    }

    return true;
  }
  










}
